/* Intentional, device-local saves; no account, tracking, or checkout changes. */
(() => {
  const KEY = 'tandoori-reading-list-v1', LIMIT = 100;
  function cleanBooks(value, origin) {
    if (!Array.isArray(value)) return [];
    const unique = new Map();
    for (const item of value.slice(0, LIMIT * 2)) {
      if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string' || !item.title.trim()) continue;
      try {
        const url = new URL(item.url, origin);
        if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?products\/[^/]+$/.test(url.pathname)) continue;
        let image = '';
        if (item.image) {
          try {
            const imageURL = new URL(String(item.image).startsWith('//') ? 'https:' + item.image : item.image, origin);
            if (imageURL.origin === origin || (imageURL.protocol === 'https:' && ['cdn.shopify.com', 'wi9rgr-id.myshopify.com'].includes(imageURL.hostname))) image = imageURL.href;
          } catch { /* A missing cover must not lose the saved book. */ }
        }
        unique.set(String(item.id), {id:String(item.id), title:item.title.slice(0,300), url:url.pathname, image});
        if (unique.size === LIMIT) break;
      } catch { /* Ignore malformed or foreign stored links. */ }
    }
    return [...unique.values()];
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {cleanBooks, LIMIT}; return; }
  if (customElements.get('tandoori-reading-list')) return;
  customElements.define('tandoori-reading-list', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.books = [];
      this.read();
      this.click = event => {
        const save = event.target.closest('[data-save-book]');
        if (save) { this.toggle(save); return; }
        if (event.target.closest('[data-reading-list-open]')) { this.render(); this.dialog.showModal(); }
      };
      this.storage = event => { if (event.key === KEY || event.key === null) { this.read(); this.refresh(); if(this.dialog.open) this.render(); } };
      document.addEventListener('click', this.click);
      window.addEventListener('storage', this.storage);
      this.close = () => this.dialog.close();
      this.querySelector('[data-library-close]').addEventListener('click', this.close);
      this.backdrop = event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) this.dialog.close(); } };
      this.dialog.addEventListener('click', this.backdrop);
      this.observer = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if(node.matches('[data-save-book]')) this.updateButton(node);
        node.querySelectorAll('[data-save-book]').forEach(button => this.updateButton(button));
      })));
      this.observer.observe(document.body, {childList:true,subtree:true});
      this.refresh();
    }
    read() { try { this.books=cleanBooks(JSON.parse(localStorage.getItem(KEY)||'[]'),location.origin); } catch { this.books=[]; } }
    write() { try { localStorage.setItem(KEY,JSON.stringify(this.books)); return true; } catch { return false; } }
    updateButton(button) {
      if (!cleanBooks([button.dataset],location.origin).length) return;
      button.hidden=false;
      const saved=this.books.some(book=>book.id===button.dataset.id), label=this.dataset[saved?'saved':'save'];
      button.setAttribute('aria-pressed',String(saved));
      button.setAttribute('aria-label',label+': '+button.dataset.title);
      button.title=label;
      const text=button.querySelector('[data-save-label]');
      if(text&&text.textContent!==label)text.textContent=label;
    }
    refresh() {
      document.querySelectorAll('[data-save-book]').forEach(button=>this.updateButton(button));
      document.querySelectorAll('[data-reading-list-open]').forEach(button=>{
        button.hidden=false;
        const count=button.querySelector('[data-reading-list-count]');
        if(count&&count.textContent!==String(this.books.length))count.textContent=String(this.books.length);
      });
    }
    announce(message) { clearTimeout(this.timer); this.querySelectorAll('[data-library-status]').forEach(node=>{node.textContent=message;}); this.timer=setTimeout(()=>{this.querySelectorAll('[data-library-status]').forEach(node=>{node.textContent='';});},5000); }
    toggle(button) {
      const book=cleanBooks([button.dataset],location.origin)[0]; if(!book)return;
      const exists=this.books.some(item=>item.id===book.id);
      if(!exists&&this.books.length>=LIMIT){this.announce(this.dataset.full);return;}
      this.books=exists?this.books.filter(item=>item.id!==book.id):[...this.books,book];
      const persisted=this.write(); this.refresh();
      this.announce(persisted?this.dataset[exists?'removed':'added']:this.dataset.storage);
    }
    render() {
      const list=this.querySelector('[data-library-items]');list.replaceChildren();
      this.querySelector('[data-library-empty]').hidden=this.books.length>0;
      for(const book of this.books){
        const row=document.createElement('li'),content=document.createElement('div'),link=document.createElement('a'),remove=document.createElement('button');
        if(book.image){const image=document.createElement('img');image.src=book.image;image.alt='';image.width=62;image.height=85;image.loading='lazy';row.append(image);}
        link.href=book.url;link.textContent=book.title;
        remove.type='button';remove.textContent=this.dataset.remove;remove.setAttribute('aria-label',this.dataset.remove+': '+book.title);
        remove.addEventListener('click',()=>{
          const index=this.books.findIndex(item=>item.id===book.id);
          this.books=this.books.filter(item=>item.id!==book.id);
          const persisted=this.write();this.refresh();this.render();
          const buttons=this.querySelectorAll('[data-library-items] button');
          (buttons[Math.min(index,buttons.length-1)]||this.querySelector('h2')).focus();
          if(!persisted)this.announce(this.dataset.storage);
        });
        content.append(link,remove);row.append(content);list.append(row);
      }
    }
    disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('click',this.click);window.removeEventListener('storage',this.storage);this.querySelector('[data-library-close]')?.removeEventListener('click',this.close);this.dialog?.removeEventListener('click',this.backdrop);clearTimeout(this.timer);this.ready=false;}
  });
})();
